import React from 'react'
import SubHeader from '../general/SubHeader';
import Hotel1 from '../assets/product/hotel1.webp';
import Hotel2 from '../assets/product/hotel2.jpg';

const HotelManagement = () => {
  return (
    <>
      <SubHeader message='Hotel Management' />

      <section className='my-5'>
        <div className='container'>

          <div className='row'>

            <div className='col-lg-8 col-12'>
              <img src={Hotel2} className='img-fluid' alt='Billing Software' />
              <p className='sec-heading'>Dectwin Hotel Management Software</p>
              <p className='text-muted'>Our Dectwin hotel management software for mobile/ android streamlines operations with features like room booking, guest management,
                billing, and food ordering. Enhance efficiency, provide exceptional guest experiences, and manage your hotel seamlessly
                with our exclusive platform.</p>

              <div className='bg-light rounded-3 px-3 py-3 my-3'>
                <p className='banner-subheading'>Hotel Management Software for Desktop/ Windows</p>
                <p className='text-muted'>Dectwin Services' Hotel Management Software in Allahabad is a comprehensive solution customized to
                  streamline your hotel operations. From seamless check-in/out processes and efficient food ordering to advanced booking and
                  bill generation, our software simplifies daily tasks. Among top 10 hotel management software in India, it offers actionable
                  insights for better decision-making, manage multiple operations effortlessly, enhance guest satisfaction, and boost efficiency with our user-friendly, feature-rich platform designed to meet the unique needs of the hospitality industry.                            </p>
              </div>

              <div className='bg-light rounded-3 px-3 py-3'>
                <p className='banner-subheading'>Features of Dectwin Hotel Software</p>
                <p className='text-muted'><strong>Staff Management & Staff Permission Handling</strong> Efficiently manage staff roles and permissions with our software. Assign specific access levels to ensure operational security while simplifying task allocation and performance tracking for smooth hotel management.<br /><br />
                  <strong>Bills & Invoices</strong> Generate professional invoices and detailed bills instantly. Automate calculations for services, manage payment records, and ensure accurate billing for an enhanced guest experience and seamless accounting.<br /><br />
                  <strong>Advance Booking</strong> Enable hassle-free advance bookings with our intuitive system. Manage reservations, track availability, and offer guests a smooth booking experience, ensuring your rooms are always optimally utilized.<br /><br />
                  <strong>Food Order in Room</strong> Manage in-room dining requests effortlessly. Let guests order food directly from their rooms while staff receives and processes orders seamlessly, enhancing convenience and service quality.</p>

              </div>

            </div>

            <div className='col-lg-4 col-12 my-2'>
                                                                      <div className='bg-light px-3 py-4 rounded-3 mb-3'>
                                <p className='fw-bold fs-5'>Get Demo of Hotel Management Software</p>
                                <button className='banner-btn1' onClick={() => window.open('https://wa.me/8707510135?text=Hey!%20Dectwin%20Services.%20I%20want%20demo%20of%20Dectwin%20Hotel%20Management%20Software.', '_blank')}>Click here for Free DEMO</button>
                                </div>
              <div className='bg-light px-3 py-4 rounded-3'>
                <p className='fw-bold fs-5'>Product Information</p>

                <div className='contact-area mb-3'>
                  <i class="fa-solid contact-icon fa-check-to-slot"></i>
                  <div>
                    <p className='fw-semibold my-0'>Check In/Out Feature</p>
                    <p className='para-text text-muted'>Simplify guest management with our check-in/out system</p>
                  </div>
                </div>

                <div className='contact-area mb-3'>
                  <i class="fa-solid contact-icon fa-burger"></i>
                  <div>
                    <p className='fw-semibold my-0'>Food Ordering</p>
                    <p className='para-text text-muted'>Streamline food service with our integrated hotel management food ordering software in Prayagraj</p>
                  </div>
                </div>

                <div className='contact-area mb-3'>
                  <i class="fa-solid contact-icon fa-ticket"></i>
                  <div>
                    <p className='fw-semibold my-0'>Advance Booking</p>
                    <p className='para-text text-muted'>Manage availability, avoid overbooking, and provide a smooth pre-arrival experience</p>
                  </div>
                </div>

                <div className='contact-area mb-3'>
                  <i class="fa-solid contact-icon fa-receipt"></i>
                  <div>
                    <p className='fw-semibold my-0'>Bill & Invoice</p>
                    <p className='para-text text-muted'>Offer transparency to guests with detailed, professionally formatted invoices</p>
                  </div>
                </div>

                <div className='contact-area mb-3'>
                  <i class="fa-solid contact-icon fa-chart-line"></i>
                  <div>
                    <p className='fw-semibold my-0'>Report Management</p>
                    <p className='para-text text-muted'>Make data-driven decisions to improve efficiency and profitability</p>
                  </div>
                </div>

                <img src={Hotel1} className='img-fluid mt-3' alt='Billing Software' />
              </div>

            </div>
            {/* right ends */}

          </div>
          {/* row ends */}

        </div>
      </section>


      {/* Pricing Section */}
<section className='my-5'>
  <div className='container text-center'>

  <div className='sec-heading text-capitalize'>Plans & Pricing</div>

<div className='row mt-4 justify-content-center'>

<div className='my-2 col-lg-4 col-md-6 col-12'>

<div className='pricing-outer'>
<div className='pricing-inner'>
  <h5 className='text-uppercase'>Basic Plan</h5>
  <div className='sec-heading'>₹ 4999/- Year</div>
  <h5 className='mt-3'><span className='text-red'><i class="fa-solid fa-tags fa-flip-horizontal"></i> Sale</span> <span className='text-decoration-line-through'>₹ 7,999</span><br />
   Yearly AMC 3,999/-</h5>
</div>

<div className='bg-light px-4 py-4 text-muted'>
  <h6>Android, Desktop</h6>
  <hr />
  <h6>Manage Rooms & Guests</h6>
  <hr />
  <h6>Guest Reports, Dues & Settlement</h6>
  <hr />
  <h6>Ease Bills/ Invoices Online</h6>
  <hr />
  <h6>Manage In Room dining</h6>
  <hr />
  <h6>Advance Room Booking</h6>
  <hr />
  <h6>Purchase Bill Entries</h6>
  </div>

</div>
{/* pricing outer ends */}
</div>
{/* column ends */}


<div className='my-2 col-lg-4 col-md-6 col-12'>

<div className='pricing-outer'>
<div className='pricing-inner'>
  <h5 className='text-uppercase'>Premium Plan</h5>
  <div className='sec-heading'>₹ 9999/- Year</div>
  <h5 className='mt-3'><span className='text-red'><i class="fa-solid fa-tags fa-flip-horizontal"></i> Sale</span> <span className='text-decoration-line-through'>₹ 15,999</span><br />
  Yearly AMC 3,999/-</h5></div>

<div className='bg-light px-4 py-4 text-muted'>
  <h6>Annual Software Maintenance</h6>
  <hr />
  <h6>Regular Updates</h6>
  <hr />
  <h6>1 Year Plan Recharge</h6>
  <hr />
  <h6>Technical Support</h6>
  <hr />
  <h6>Online Assistance</h6>
  <hr />
  <h6>Minor Customizations</h6>
</div>

</div>
{/* pricing outer ends */}
</div>
{/* column ends */}


</div>
{/* row ends */}

  </div>
</section>
{/* Pricing Section ends */}



    </>
  )
}

export default HotelManagement
